import { jsxs as c, jsx as r } from "@emotion/react/jsx-runtime";
import { StickerContainer as S, StyledIcon as a, StickerItemContainer as g, StickerItem as u, getColorText as x } from "./Sticker.styled.js";
import { Icon as n } from "../Icon/index.js";
import { Text as b } from "../Text/index.js";
const C = ({
  dataTrackId: p,
  children: t,
  shape: f = "cube",
  disabled: l = !1,
  icon: o,
  iconPosition: i = "right",
  appearance: m = "alpha",
  variant: e = "primary",
  ellipsis: s = !0
}) => /* @__PURE__ */ c(S, { "data-track": p, disabled: l, variant: e, appearance: m, shape: f, children: [
  o && i === "left" && /* @__PURE__ */ r(a, { role: "button", "aria-label": "Close tag", children: /* @__PURE__ */ r(n, { color: e, icon: o, iconSize: "12px" }) }),
  /* @__PURE__ */ r(g, { children: /* @__PURE__ */ c(u, { variant: e, ellipsis: s, "aria-disabled": l, children: [
    typeof t == "string" && /* @__PURE__ */ r(b, { variant: "bodySMedium", color: x(e, m), oneLine: !0, children: t }),
    typeof t != "string" && t
  ] }) }),
  o && i === "right" && /* @__PURE__ */ r(a, { role: "button", "aria-label": "Close tag", children: /* @__PURE__ */ r(n, { color: e, icon: o, iconSize: "12px" }) })
] });
export {
  C as Sticker
};
